import React, { Component } from 'react'
import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'

import {
  fetchCompanyOptions,
  fetchFormOptionsForAppraisal,
  fetchLevelGroupOptionsForAppraisal,
  fetchOrganizationOptionsForAppraisal,
  fetchPositionOptionsForAppraisal,
  fetchStructureOptionsForAppraisal,
  // fetchEmployeeOptionsForAppraisal,
  fetchEmpDetailOptions,
  fetchAppraisalData,
  clearFilteredAppraisalRecords,
  fetchAppraisalTypeOptionsForAppraisal,
  // fetchAppraisalStatusOptionsForAppraisal,
  fetchItemForPerformanceTrend,
  fetchDashboardPerformanceTrendAll,
  fetchDashboardPerformanceTrendChart,
  enqueueSnackbar
} from '../../../../store/actions'

import {
  clearFilterOptionValues,
  updateFilterOptions,
  updateObject
} from '../../../../helpers/utils'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import ActionBar from '../../../../components/ActionBar/ActionBar'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'

import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import PageInfo from '../../../../components/PageInfo/PageInfo'

// import FilterBar from '../../../../components/FilterBar/FilterBar'

import PerformanceTrendContent from '../../../../components/PageContent/Dashboard/PerformanceTrend/PerformanceTrendContent'

class PerformanceTrend extends Component {
  state = {
    // Filter Modal States
    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: []
        },

        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structure'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: true
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: [],
          disabled: false
        },
        required: false
      },
      emp_detail_id: {
        label: this.props.translate('employee'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: [],
          disabled: false
        },
        required: false
      },
      item_id: {
        label: this.props.translate('kpi'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('kpi'),
          options: [],
          disabled: false
        },
        required: true
      }
    },
    filterOptions: {
      appraisalTypeOptions: null,
      companyFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      levelGroupFilterOptions: null,
      orgFilterOptions: null,
      positionFilterOptions: null,
      empFilterOptions: null,
      itemFilterOptions: null
    },

    // Import Modal States
    importModalOpen: false,
    importFile: null,

    // Presentational State
    appraisalType: null,
    company: null

    // Cache
    // filteredCache: null
  }

  componentDidMount = () => {
    this.props.fetchAppraisalTypeOptions()
    this.props.fetchCompanyOptions()

    if (this.props.filtered) {
      const { appraisalType, company } = this.props.filtered

      this.props.filterAppraisalRecords(this.props.filtered)

      this.setState({
        appraisalType,
        company
      })
    }
  }

  static getDerivedStateFromProps (props, state) {
    let updatedState = { ...state }
    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }
    // filter appraisal type
    if (
      props.filterOptions.appraisalTypeOptions !== updatedState.filterOptions.appraisalTypeOptions
    ) {
      const appraisalTypeFilter = updatedState.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.appraisalTypeOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' },
        'Select Appraisal Type',
        false,
        updatedState.filterControls.appraisal_type_id.value,
        'appraisal_type_code'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeOptions: props.filterOptions.appraisalTypeOptions
        }
      }
    }
    // filter company
    if (
      props.filterOptions.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions
    ) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    // filter form
    if (props.filterOptions.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        // { name: 'form_name', code: 'form_id' },
        'Select Form'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          form_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    // filter structure
    if (
      props.filterOptions.structureFilterOptions !==
      updatedState.filterOptions.structureFilterOptions
    ) {
      const structureFilter = updatedState.filterControls.structure_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )

      const { structureFilterOptions } = props.filterOptions
      let defaultValue = ''
      if (structureFilterOptions && structureFilterOptions.length > 0) {
        const target = structureFilterOptions.find(s => s.structure_id === 1)
        if (target) {
          defaultValue = {
            key: target.structure_id,
            value: target.structure_id,
            label: target.structure_name
          }
        }
      }
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          structure_id: {
            ...updatedFilterItem,
            value: defaultValue
          }
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.filterOptions.structureFilterOptions
        }
      }
    }
    // filter level group
    if (
      props.filterOptions.levelGroupFilterOptions !==
      updatedState.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level group'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    // filter org
    if (props.filterOptions.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        'org_name',
        'Select org'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          org_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    // filter position
    if (
      props.filterOptions.positionFilterOptions !== updatedState.filterOptions.positionFilterOptions
    ) {
      const positionFilter = updatedState.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    // filter emp
    if (props.filterOptions.empFilterOptions !== updatedState.filterOptions.empFilterOptions) {
      const employeeFilter = updatedState.filterControls.emp_detail_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.empFilterOptions,
        employeeFilter,
        'emp_detail_id',
        'emp_detail_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          emp_detail_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.filterOptions.empFilterOptions
        }
      }
    }
    // filter item
    if (props.filterOptions.itemFilterOptions !== updatedState.filterOptions.itemFilterOptions) {
      const itemFilter = updatedState.filterControls.item_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.itemFilterOptions,
        itemFilter,
        'item_id',
        'item_id',
        { name: 'item_name', code: 'item_code' },
        'Select item'
      )

      updatedState = {
        filterControls: updateObject(updatedState.filterControls, {
          item_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          itemFilterOptions: props.filterOptions.itemFilterOptions
        }
      }
    }

    return {
      ...updatedState,
      filteredCache: props.filtered
    }
  }

  // Cleaner Methods
  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter,
      filteredCache: null
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    }
  }

  // Filter Modal Methods
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    let filterOptions = {
      appraisal_type_id: updatedFilterControls.appraisal_type_id.value?.value,
      company_id: updatedFilterControls.company_id.value?.value,
      structure_id: updatedFilterControls.structure_id.value?.value,
      level_group_id: updatedFilterControls.level_group_id.value?.value,
      org_id: updatedFilterControls.org_id.value?.value,
      position_id: updatedFilterControls.position_id.value?.value,
      emp_detail_id: updatedFilterControls.emp_detail_id.value?.value
    }

    if (itemKey === 'appraisal_type_id') {
      const { label } = event
      const { filterControls } = this.state
      if (label.includes('Individual')) {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = false
        filterControls.position_id.required = false
        filterControls.emp_detail_id.required = true

        filterControls.position_id.configs.disabled = false
        filterControls.emp_detail_id.configs.disabled = false
      } else {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = true
        filterControls.position_id.required = false
        filterControls.emp_detail_id.required = false

        filterControls.position_id.configs.disabled = true
        filterControls.emp_detail_id.configs.disabled = true
      }

      updatedFilterControls = {
        ...updatedFilterControls
      }
    }

    if (['company_id', 'appraisal_type_id'].includes(itemKey) && filterOptions.appraisal_type_id) {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchItemsOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchItemsOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchItemsOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchItemsOptions(filterOptions)
    } else if (itemKey === 'emp_detail_id') {
      if (
        typeof event === 'object' &&
        (updatedFilterControls.org_id.value === null || updatedFilterControls.org_id.value === '')
      ) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_detail_id === event.value
        )
        let org_id = findEmp.org_id

        updatedFilterControls.org_id.value = updatedFilterControls.org_id.configs.options.find(
          item => item.value === org_id
        )
        filterOptions = {
          appraisal_type_id: updatedFilterControls.appraisal_type_id.value?.value,
          company_id: updatedFilterControls.company_id.value?.value,
          structure_id: updatedFilterControls.structure_id.value?.value,
          level_group_id: updatedFilterControls.level_group_id.value?.value,
          org_id: updatedFilterControls.org_id.value?.value,
          position_id: updatedFilterControls.position_id.value?.value,
          emp_detail_id: updatedFilterControls.emp_detail_id.value?.value
        }
      }

      if (
        typeof event === 'object' &&
        (updatedFilterControls.position_id.value === null ||
          updatedFilterControls.position_id.value === '')
      ) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_detail_id === event.value
        )
        let position_id = findEmp.position_id

        updatedFilterControls.position_id.value =
          updatedFilterControls.position_id.configs.options.find(
            item => item.value === +position_id
          )
        filterOptions = {
          appraisal_type_id: updatedFilterControls.appraisal_type_id.value?.value,
          company_id: updatedFilterControls.company_id.value?.value,
          structure_id: updatedFilterControls.structure_id.value?.value,
          level_group_id: updatedFilterControls.level_group_id.value?.value,
          org_id: updatedFilterControls.org_id.value?.value,
          position_id: updatedFilterControls.position_id.value?.value,
          emp_detail_id: updatedFilterControls.emp_detail_id.value?.value
        }
      }
      this.props.fetchItemsOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  componentWillUnmount () {
    this.clearFilter()
  }

  getItem = item => {
    let filterControls = { ...this.state.filterControls }
    this.setState({
      filterControls: {
        ...filterControls,
        item_id: {
          ...filterControls.item_id,
          value: item
        }
      }
    })
  }

  filterRecords = () => {
    // const pageOptions = {
    //   perPage: this.props.pagination.perPage,
    //   page: this.props.pagination.currentPage
    // }
    // const filters = extractFilterOptions(this.state.filterControls, pageOptions)
    const appraisalType = this.state.filterControls.appraisal_type_id.value
    const company = this.state.filterControls.company_id.value
    this.setState({
      appraisalType: appraisalType,
      company: company
    })

    // this.props.filterAppraisalRecords({ ...filters, appraisalType, company });
    this.closeFilterModal(true)

    // const { label } = appraisalType
    // const labelArray = label.split(' ')
    // this.fetchData({
    //   ...filters,
    //   company_id: filters.company_id,
    //   org_id: filters.org_id,
    //   form_id: filters.form_id,
    //   appraisal_type_code: labelArray[0]
    // })

    let param = {
      company_id: this.state.filterControls?.company_id?.value?.value,
      appraisal_type_id: this.state.filterControls?.appraisal_type_id?.value?.value,
      form_id: this.state.filterControls?.form_id?.value?.value,
      structure_id: this.state.filterControls?.structure_id?.value?.value,
      org_id: this.state.filterControls?.org_id?.value?.value,
      emp_detail_id: this.state.filterControls?.emp_detail_id?.value?.value,
      item_id: this.state.filterControls?.item_id?.value?.value
    }
    this.props.fetchDashboardPerformanceTrendChart(param)
    this.props.fetchDashboardPerformanceTrendAll(param)
  }

  render () {
    const { filterControls } = this.state

    let content = (
      <PerformanceTrendContent
        chartData={this.props.chartData}
        allData={this.props.allData}
        filterControls={this.state.filterControls}
        filterOptions={this.props.filterOptions}
        formLoading={this.props.formLoading}
        fetchDashboardPerformanceTrendChart={param =>
          this.props.fetchDashboardPerformanceTrendChart(param)
        }
        fetchDashboardPerformanceTrendAll={param =>
          this.props.fetchDashboardPerformanceTrendAll(param)
        }
        getItem={item => {
          this.getItem(item)
        }}
      />
    )

    if (!this.props.filtered) {
      content = <PleaseFilter />

      if (this.props.filterLoading === true) {
        content = <Spinner />
      }
    }

    return (
      <Aux>
        <Alert />
        <FilterModal
          open={this.state.filterModalOpen}
          filterControls={filterControls}
          filterSaved={this.filterRecords}
          filterChanged={this.filterChangedHandler}
          cancelled={this.closeFilterModal}
          loadingQueue={this.props.loadingQueue}
        />
        <Card>
          <CardHeader>
            <ActionBar
              filtering={this.openFilterModal}
              show={['filter']}
              leftContent={<PageInfo pageTranslateKey={'performanceTrend'} />}
            />
            {/* <FilterBar buttonClicked={this.openFilterModal} /> */}
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const {
    filterStructures,
    filterItems,
    chartData,
    allData,
    filterEmps,
    filtered,
    filterForms,
    filterAppraisalTypes,
    filterLevelGroups,
    filterOrgs,
    filterPositions,
    filterLoading,
    filterCompanies,
    loadingStates,
    formLoading
  } = state.dashboardPerformanceTrend

  return {
    chartData: chartData,
    allData: allData,

    filtered: filtered,
    formLoading: formLoading,
    filterLoading: filterLoading,

    records: state.appraisal.records,
    pagination: state.appraisal.pagination,
    imported: state.appraisal.imported,

    filterOptions: {
      appraisalTypeOptions: filterAppraisalTypes,
      companyFilterOptions: filterCompanies,
      formFilterOptions: filterForms,
      structureFilterOptions: filterStructures,
      levelGroupFilterOptions: filterLevelGroups,
      orgFilterOptions: filterOrgs,
      positionFilterOptions: filterPositions,
      empFilterOptions: filterEmps,
      itemFilterOptions: filterItems
    },

    loadingQueue: loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // Alert
    fireAlert: alertOption => {
      dispatch(enqueueSnackbar(alertOption))
    },
    // Filter
    fetchAppraisalTypeOptions: () => dispatch(fetchAppraisalTypeOptionsForAppraisal()),
    fetchCompanyOptions: () => dispatch(fetchCompanyOptions()),
    fetchFormOptions: filterOptions => dispatch(fetchFormOptionsForAppraisal(filterOptions)),
    fetchStructureOptions: filterOptions =>
      dispatch(
        fetchStructureOptionsForAppraisal({
          ...filterOptions,
          structure_type_code: ['STT01', 'STT04']
        })
      ),
    fetchLevelGroupOptions: filterOptions =>
      dispatch(fetchLevelGroupOptionsForAppraisal(filterOptions)),
    fetchOrgOptions: filterOptions => dispatch(fetchOrganizationOptionsForAppraisal(filterOptions)),
    fetchPositionOptions: filterOptions =>
      dispatch(fetchPositionOptionsForAppraisal(filterOptions)),
    // fetchEmployeeOptions: filterOptions =>
    //   dispatch(fetchEmployeeOptionsForAppraisal(filterOptions)),
    fetchEmployeeOptions: filterOptions => dispatch(fetchEmpDetailOptions(filterOptions)),
    // fetchStatusOptions: filterOptions =>
    //   dispatch(fetchAppraisalStatusOptionsForAppraisal(filterOptions)),
    filterAppraisalRecords: filterOptions => dispatch(fetchAppraisalData(filterOptions)),
    fetchItemsOptions: filterOptions => dispatch(fetchItemForPerformanceTrend(filterOptions)),
    clearFilteredAppraisalRecords: () => dispatch(clearFilteredAppraisalRecords()),
    fetchDashboardPerformanceTrendAll: param => dispatch(fetchDashboardPerformanceTrendAll(param)),
    fetchDashboardPerformanceTrendChart: param =>
      dispatch(fetchDashboardPerformanceTrendChart(param))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(PerformanceTrend))
